module.exports = __webpack_public_path__ + "static/hero-592baf4c047d386d795986a15e8144d9.jpg";